import type {
	CustomItem,
	DropSpinsStylesType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropSpinsStyles = (
	item: Item | CustomItem
): item is DropSpinsStylesType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Spins_Styles'
	);
};
